<cdk-tree [dataSource]="dataSource" [treeControl]="treeControl">
<!--    <ng-container *ngIf="headerRows.length">-->
<!--        <ng-container *ngFor="let hr of headerRows" [ngTemplateOutlet]="hr.templateRef"></ng-container>-->
<!--    </ng-container>-->
    <cdk-tree-node *matTreeNodeDef="let node" >
<!--        <button mat-icon-button disabled></button>-->
<!--        {{ node.position }}-->
<!--        <ng-content select="[appArlTreeRow]"></ng-content>-->
        <ng-container *ngIf="row" [ngTemplateOutlet]="row.templateRef" [ngTemplateOutletContext]="{$implicit: node, expanded: treeControl.isExpanded(node), index: treeControl.dataNodes.indexOf(node)}"></ng-container>

    </cdk-tree-node>

<!--    <cdk-tree-node *matTreeNodeDef="let node; when: hasChild" >-->
<!--&lt;!&ndash;        <button mat-icon-button cdkTreeNodeToggle [attr.aria-label]="'Toggle ' + node.position">&ndash;&gt;-->
<!--&lt;!&ndash;            <fa-icon icon="{{ treeControl.isExpanded(node) ? 'chevron-down' : 'chevron-right' }}"></fa-icon>&ndash;&gt;-->
<!--&lt;!&ndash;        </button>&ndash;&gt;-->
<!--&lt;!&ndash;        {{ node.position }}&ndash;&gt;-->
<!--&lt;!&ndash;        <ng-content select="[appArlTreeRow]" ></ng-content>&ndash;&gt;-->

<!--        <ng-container *ngIf="row" [ngTemplateOutlet]="row.templateRef" [ngTemplateOutletContext]="{$implicit: node, expanded: treeControl.isExpanded(node)}"></ng-container>-->
<!--    </cdk-tree-node>-->
</cdk-tree>
<!--{{row | json}}-->
